
import React, {useEffect, useState} from 'react';


import {
} from '../../api/methodPayment.api';

import {connect} from 'react-redux';
import toastr from 'toastr';
import html2pdf from 'html2pdf.js';
import LoftyDropdownComponent from '../../components/loftydropdowncomponent';
import LoftyCountDown from '../../components/loftycountdown';
import LoftyCartCarousel from '../../components/loftycartcarousel';
import LoftyThreeCarousel from '../../components/loftythreecarousel';
import LoftyCarouselPlugin from '../../components/LoftyCarouselPlugin';
import LoftyLeaftMap from '../../components/loftyLeaftMaps';
import LoftyAnimatedParticleBackground from '../../components/loftyAnimatedParticleBackground';
import LoftyGoogleLoginComponent from '../../components/loftyGoogleLoginComponent';
import LoftyEditorJsReadOnly from '../../components/LoftyEditorJsReadOnly';
import LoftyEditorJs from '../../components/LoftyEditorJs';

import { addLoftyToken, deleteLoftytoken } from '../../actions/auth.actions';

import {customlistadodeestudiosrvquh_69745c44a85c3d434df35756 } from '../../api/publicacindeestudior78or.api'

import './estudios5k5d2.scss';


// Hamburger
function loftyInitHam() {
  try {
  // eslint-disable-next-line no-restricted-globals
    window.addEventListener('click', (event) => {
      let originPointLeft = '';
      const comp = event.target.className;
      if (comp.includes('menu__btn') || comp.includes('span_middle') || comp.includes('span_before') || comp.includes('span_after')) {
        const res = Array.from(document.getElementsByClassName('menu__box'));
        const spanData = Array.from(document.getElementsByClassName('menu__btn'));
        const closeBtn = Array.from(document.getElementsByClassName('menu__close__btn'));
        spanData.forEach((item) => {
          originPointLeft = item.style.left;
        });
        res.forEach((item) => {
          item.style.left = '0px';
        });
        spanData.forEach((item) => {
          item.style.left = '-300px';
        });
        closeBtn.forEach((item) => {
          item.style.left = '10px';
        });
      } else {
        if (comp === 'menu__box') {
          return;
        }
        if (comp === 'linkshref') {
          return;
        }
        if (comp === 'menu__item') {
          return;
        }
        const res = Array.from(document.getElementsByClassName('menu__box'));
        const spanData = Array.from(document.getElementsByClassName('menu__btn'));
        const closeBtn = Array.from(document.getElementsByClassName('menu__close__btn'));
        res.forEach((item) => {
          item.style.left = '-300px';
        });
        spanData.forEach((item) => {
          item.style.left = originPointLeft;
        });
        closeBtn.forEach((item) => {
          item.style.left = '-100%';
        });
      }
    });
  } catch (error) {
    // console.log(error);
  }
}    
    






const Pestudios5k5d2 = ({
  match,
  history,
  loftytoken,
  loftyuser,
  addLoftyUserApp,
  deleteLoftytokenApp,
  addLoftyTokenApp,
  
}) => {

	const [loftyres_69745c44a85c3d434df35756_component_iz67p, setloftyres_69745c44a85c3d434df35756_component_iz67p] = useState([]);


useEffect(() => {
		const loftyHandleData = async () => {
		}
		loftyHandleData();
	}, []);

	useEffect(() => {
		const handleLoftyData = async () => {
			try {
				const responseLoftyApps = await customlistadodeestudiosrvquh_69745c44a85c3d434df35756({
				});
				setloftyres_69745c44a85c3d434df35756_component_iz67p(responseLoftyApps.data);
			} catch (loftyerror) {
			}
		}
		handleLoftyData();
	}, []);



  
  setTimeout(() => { loftyInitHam(); }, 2000);

  
  

  
  return (
    <div id="id69745f738e5aed52dc8f1dd6" >

      <div id="i9ol" className="">
      
      <div id="icjbu5" className="">
      
      <img
        className=""
        id="iwbvf5"
        src="https://assetsprojects.s3.amazonaws.com/404pziimfhcxkni.png"
        alt="undefined"
      />
      
      </div>
      
      <div id="ipwig4" className="">
      
        <a
          target=""
          className=""
          id="idtfhs"
          href="/estudios"
        >
          
    <div id="ifgmx9" className="">
    <>Estudios</>
    </div>
    
        </a>
        
        <a
          target=""
          className=""
          id="ivw47x"
          href={`/contact`}
        >
          
    <div id="iv1mlt" className="">
    <>Contacto</>
    </div>
    
        </a>
        
      </div>
      
      <div id="" className="contentwrapperanimated ">
      
      <div id="" className="container_animated ">
      
      <label id="" className="menu__btn ">
      
      <span className="span_before " id="">
        
      </span>
      
      <span className="span_middle " id="">
        
      </span>
      
      <span className="span_after " id="">
        
      </span>
      
      </label>
      
      <label id="" className="menu__close__btn ">
      
      <span className="span__close__left " id="">
        
      </span>
      
      <span className="span__close__right " id="">
        
      </span>
      
      </label>
      
      <ul id="" className="menu__box ">
        
      <li className="linkshref " id="">
        
      <a
        target=""
        className="menu__item "
        id=""
        href="/"
        type=""
      >
        <>Inicio</>
      </a>
      
      </li>
      
      <li className="linkshref " id="">
        
      <a
        target=""
        className="menu__item "
        id=""
        href="/acerca"
        type=""
      >
        <>Sobre nosotros</>
      </a>
      
      </li>
      
      <li className="linkshref " id="">
        
      <a
        target=""
        className="menu__item "
        id=""
        href="/estudios"
        type=""
      >
        <>Estudios</>
      </a>
      
      </li>
      
      <li className="linkshref " id="">
        
      <a
        target=""
        className="menu__item "
        id=""
        href="/contact"
        type=""
      >
        <>Contacto</>
      </a>
      
      </li>
      
      <li className="linkshref " id="">
        
      </li>
      
      </ul>
      
      </div>
      
      </div>
      
      </div>
      
      <div id="iizt" className="">
      
      <div id="iwdy" className="">
      
      <div className="" id="i1hzn">
        <>Estudios</>
      </div>
      
      </div>
      
      </div>
      
      <div id="ifgm" className="">
      
      <div id="irers" className="">
      
        <a
          target=""
          className=""
          id="iuuhyl"
          href="#"
        >
          
      <span className="" id="iy1fm9">
        <>Ver Mas</>
      </span>
      
        </a>
        
      </div>
      
        <div id="iz67p" className="">
        
            {
              loftyres_69745c44a85c3d434df35756_component_iz67p.map((loftyitem_69745c44a85c3d434df35756_component_iz67p) => (
                <div key={loftyitem_69745c44a85c3d434df35756_component_iz67p._id} className="" id="is4qc">
                  
      <div id="i2fcg" className="">
      
      <div id="igldc" className="">
      
        <img
          className=""
          id="iyqub"
          alt=""
          src={loftyitem_69745c44a85c3d434df35756_component_iz67p.loftyUrl}
        />
        
      </div>
      
        <a
          target=""
          className=""
          id="isot6"
          href={`/estudios/${loftyitem_69745c44a85c3d434df35756_component_iz67p._id}`}
        >
          
        <div className="" id="il90d">
          
          <div className="" id="iuilj">
            {loftyitem_69745c44a85c3d434df35756_component_iz67p?.pas7z0bn}
          </div>
          
        </div>
        
        <div className="" id="ievdq">
          
          <div className="" id="">
            {loftyitem_69745c44a85c3d434df35756_component_iz67p?.titulo2lvs3}
          </div>
          
        </div>
        
        <div className="" id="i8lej">
          
          <div className="" id="">
            {loftyitem_69745c44a85c3d434df35756_component_iz67p?.descripcincortav6uva}
          </div>
          
        </div>
        
        </a>
        
      </div>
      
                </div>
              ))
            }
            
        </div>
        
      </div>
      
      <div id="ii5t" className="">
      
      <div id="id4e2" className="">
      
      <div className="" id="iglijz">
        <>Copyright © 2025 M2GlobalInsigths ORG</>
      </div>
      
      </div>
      
      </div>
      
</div>
  );
}

const mapStateToProps = (state) => state.auth;

const mapDispatchToProps = (dispatch) => ({
 addLoftyTokenApp: (data) => dispatch(addLoftyToken(data)),
 deleteLoftytokenApp: () => dispatch(deleteLoftytoken()),
});


export default connect(mapStateToProps, mapDispatchToProps)(Pestudios5k5d2);
  